<template>
    <v-snackbar
            top
            v-model="snackbar"
            :color="color"
            :multi-line="mode === 'multi-line'"
            :timeout="timeout"
            :vertical="mode === 'vertical'">
        {{ text }}
        <v-btn
                dark
                flat
                @click="snackbar = false">
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        name: "MySnackBar",
        data() {
            return {
                snackbar: this.snackbarShow,
                color: this.snackbarHintType,
                mode: '',
                timeout: 3000,
                text: this.snackbarContent
            }
        },
        props: {
            snackbarShow: Boolean,
            snackbarContent: String,
            snackbarHintType: String
        },
        watch: {
            snackbarShow(to, from) {
                this.snackbar = to
            },
            snackbarContent(to, from) {
                this.text = to
            },
            snackbarHintType(to, from) {
                this.color = to
            },
            snackbar(to, from) {
                if (!to) {
                    this.$emit("close")
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Snackbar.vue?2dd1c693